import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { trimObjectStrings } from 'utils'
import Item from './item'
import { fetch, update, remove } from '../../actions'

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps
  const dataBooking = state.requestVehicleRelocations.data?.[id] || null
  const dataContract = state.requestVehicleRelocations.related?.[dataBooking?.agreementNo] || null
  const fetchStatus = state.requestVehicleRelocations.flags?.fetch || 'none'
  const saveStatus = state.requestVehicleRelocations.flags?.update || 'none'
  const fleetIds = state.settings.fleet.selected
  const userRoles = state.settings.roles

  let data = {
    booking: trimObjectStrings(dataBooking),
  }
  if (dataContract) {
    data.contract = trimObjectStrings(dataContract)
  }

  return {
    id,
    data,
    fleetIds,
    fetchStatus,
    saveStatus,
    userRoles
  }
}

const mapDispatchToProps = (dispatch) => ({
  onFetch: (id, fleetIds) => {
    const FleetId = fleetIds.join(',')
    dispatch(fetch(null, {
      resourceId: id,
      queryParams: { FleetId }
    }))
  },
  onUpdate: (payload) => {
    dispatch(update(payload, {
      resourceId: payload.id,
    }))
  },
  onDelete: (id, fleetId) => {
    dispatch(remove(null, {
      resourceId: id,
      queryParams: { fleetId }
    }))
  },
})

const ItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Item)

const ItemWithParams = (props) => {
  const { id } = useParams()
  return <ItemContainer {...props} id={id} />
}

export default ItemWithParams
